

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'

import Cookies from 'js-cookie'
import { getTokenSyn } from '@/utils/auth'
import { getQueryNew } from '@/utils/index'
import {
updateLinkID,
pageView
} from '@/api/other'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import 'lib-flexible' 

Vue.use(ToastPlugin, { position: 'top' })
Vue.use(LoadingPlugin)
Vue.use(WechatPlugin)
Vue.use(ConfirmPlugin)
Vue.use(router)
Vue.use(AjaxPlugin)

FastClick.attach(document.body)

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {

try {
window.localStorage.setItem('test', 'support localStorage')
window.localStorage.getItem('test')
console.log(window.localStorage.getItem('test'))
} catch (error) {

Vue.$vux.confirm.show({
title: '提示',
content: '当前浏览器版本过低或禁用本地存储，请更换浏览器!',
showCancelButton: false,
showConfirmButton: false,


})
return
}
if (process.env.NODE_ENV === 'production') {

console.log(navigator.userAgent)
var agent = navigator.userAgent.toLowerCase()
var curUri = window.location.href.indexOf('/weixin') 

if (agent.match(/MicroMessenger/i) == "micromessenger" && curUri == -1) {

console.log('weixin')
let uri = window.location.href.split('/wap')[0] + '/weixin' + window.location.href.split('/wap')[1]

window.location.href = window.location.href.split('/wap')[0] + '/weixin' + window.location.href.split('/wap')[1]
return
} else if (agent.match(/MicroMessenger/i) != "micromessenger" && window.location.href.indexOf('/wap/') == -1) {
console.log('wap')
let uri = window.location.href.split('/weixin')[0] + '/wap' + window.location.href.split('/weixin')[1]


window.location.href = window.location.href.split('/weixin')[0] + '/wap' + window.location.href.split('/weixin')[1]
return
}

const postData = {

page: 'https://' + window.location.host + '/wap/index.html#' + to.fullPath
}
pageView(postData)
.then(res => {
if (res.data.errorcode === 0) {
console.log('访问统计成功！')
} else {
console.log(`访问统计失败${res.data.errormsg}`)
}
})
.catch(err => {
console.log('访问统计失败')
})
}


Vue.$vux.loading.show()

const shareid = getQueryNew('shareid')
if (shareid) {

const postData = {
linkid: shareid
}

updateLinkID(postData)
.then(res => {
if (res.data.errorcode === 0) {





} else {
console.log('更新分享上家id失败')

}



init()
})
.catch(err => {
console.log(err)
next()


})
} else {
init()
}


function init () {

if (to.meta.requireLogin && localStorage.getItem('accountIsLogin') !== 'true') {

next('/login')
return
}

const tokenStr = window.localStorage.getItem('token')
const tokenJson = JSON.parse(tokenStr)
const timestamp = Date.parse(new Date())
const isLogin = window.localStorage.getItem('isLogin')
console.log(!tokenJson)
console.log(!isLogin)
console.log(to.path !== '/author')

if (!tokenJson) {


getTokenSyn()
.then(res => {
if (res.data.errorcode === 0) {

const JsonObj = {
token: res.data.data.token,
time: res.data.data.expirestime
}
console.log(`获取成功${res.data.data.token}`)
localStorage.setItem('token', JSON.stringify(JsonObj))
if (res.data.data.islogin === 1) {
localStorage.setItem('isLogin', true)
localStorage.setItem('shareid', res.data.data.shareid)
} else {
localStorage.setItem('isLogin', false)
localStorage.setItem('shareid', res.data.data.shareid)
}
next()
} else {
Vue.$vux.toast.text('获取token失败')

next()
console.log('重新获取失败')
}
})
.catch(err => {
Vue.$vux.toast.text('获取token失败')

next()
console.log(err)
})
next()
return false
} else if (tokenJson && timestamp + 200000 > tokenJson.time * 1000) {

console.log('token过期重新获取')

getTokenSyn()
.then(res => {
if (res.data.errorcode === 0) {

const JsonObj = {
token: res.data.data.token,
time: res.data.data.expirestime
}
console.log(`获取成功${res.data.data.token}`)
localStorage.setItem('token', JSON.stringify(JsonObj))
if (res.data.data.islogin === 1) {
localStorage.setItem('isLogin', true)
localStorage.setItem('shareid', res.data.data.shareid)
} else {
localStorage.setItem('isLogin', false)
localStorage.setItem('shareid', res.data.data.shareid)
}
next()
} else {
Vue.$vux.toast.text('获取token失败')

next()
console.log('重新获取失败')
}
})
.catch(err => {
Vue.$vux.toast.text('获取token失败')

next()
console.log(err)
})
return
} else if (tokenJson && to.path === '/login' && localStorage.getItem('accountIsLogin') === 'true') {
console.log('已登录')
next('/usercenter')
return
} else if (to.path === '/login' || to.path === '/register') {

console.log(`要去的地址：${from.path}`)
console.log(from)
localStorage.setItem('beforeLoginPath', from.path)
localStorage.setItem('beforeLoginQuery', JSON.stringify(from.query))
localStorage.setItem('beforeLoginFullpath', from.fullPath)
}

if (to.path === '/address' && from.path === '/confirmOrder') {
localStorage.setItem('beforeConfirmPath', from.fullPath)
}
next()
}
})
router.afterEach((to, from, next) => {

Vue.$vux.loading.hide()

document.title = to.meta.title
})
/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js